<template>
  <v-container class="my-5">
    <!--     Dialog para Mostrar Codigo QR del Trabajador     -->
    <v-dialog v-model="dialogQR" max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ $t('qr_code') }}
        </v-card-title>
        <v-card-text>
          <h3>{{ contractors.first_name }} {{ contractors.last_name }}</h3>
          <v-flex xs12>
            <v-img class="pt-3 pb-3"
              :src="'https://api.qrserver.com/v1/create-qr-code/?data=' + contractors.qr_code + '&ecc=M&margin=20&size=400x400'"
              width="250" height="250"></v-img>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialogQR = false">
            {{ $t('aceptar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--     Dialog para Mostrar mensaje "Seleccionar al menos un día de la Semana"       -->
    <v-dialog v-model="dialogAtLeastOneDay" max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ $t('aviso') }}
        </v-card-title>
        <v-card-text>
          {{ $t('msg_no_days') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialogAtLeastOneDay = false">
            {{ $t('aceptar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--   Diálogo para Mostrar un mensaje al Eliminar Residentes     -->
    <v-dialog v-model="deleteDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">
          {{ $t('msg_delete_contractor') }}
        </v-card-title>
        <v-card-text>
          {{ $t('msg_accion_deshacer') }}
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="deleteDialog = false">
            No
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="deletecontractor()">
            {{ $t('Si') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="sendInfoDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">
          {{ $t('msg_send_contractor') }}
        </v-card-title>
        <v-card-text>
          {{ $t('msg_accion_enviar') }}
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="sendInfoDialog = false" :disabled="loadingSendInfo">
            No
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn :loading="loadingSendInfo" :disabled="loadingSendInfo" color="primary" @click="sendContractorInfo">
            {{ $t('aceptar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Frontal      -->
    <v-dialog v-model="dialogImageFront" persistent scrollable max-width="800px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            {{ $t('recortar_imagen') }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <clipper-fixed :rotate="degrees" :ratio="ratio" ref="clipperImageFront" :src="imageFrontURL">
          </clipper-fixed>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-col>
            <v-row xs12 class="justify-center">
              <v-radio-group v-model="ratio" name="ratio" row label="Ratio" :mandatory="false">
                <v-radio label="1:1" value="1"></v-radio>
                <v-radio label="3:2" value="1.5"></v-radio>
                <v-radio label="4:3" value="1.3333333333333333"></v-radio>
                <v-radio label="16:9" value="1.7777777777777777"></v-radio>
              </v-radio-group>
            </v-row>
            <v-row xs12 class="justify-center mr-6">
              <v-slider v-model="degrees" :label="$t('grados')" step="1" max="180" min="-180"
                thumb-label="always"></v-slider>
            </v-row>
            <v-row class="justify-center">
              <v-btn color="primary" @click="getCuttingFront()">{{ $t('recortar') }}</v-btn>
            </v-row>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Posterior      -->
    <v-dialog v-model="dialogImageBack" persistent scrollable max-width="800px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            {{ $t('recortar_imagen') }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <clipper-fixed :rotate="degrees" :ratio="ratio" ref="clipperImageBack" :src="imageBackURL">
          </clipper-fixed>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-col>
            <v-row xs12 class="justify-center">
              <v-radio-group v-model="ratio" name="ratio" row label="Ratio" :mandatory="false">
                <v-radio label="1:1" value="1"></v-radio>
                <v-radio label="3:2" value="1.5"></v-radio>
                <v-radio label="4:3" value="1.3333333333333333"></v-radio>
                <v-radio label="16:9" value="1.7777777777777777"></v-radio>
              </v-radio-group>
            </v-row>
            <v-row xs12 class="justify-center mr-6">
              <v-slider v-model="degrees" :label="$t('grados')" step="1" max="180" min="-180"
                thumb-label="always"></v-slider>
            </v-row>
            <v-row class="justify-center">
              <v-btn color="primary" @click="getCuttingBack()">{{ $t('recortar') }}</v-btn>
            </v-row>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--     Diálogo Modal Persistente para Recortar la Foto de perfil      -->
    <v-dialog v-model="dialogImageProfile" persistent scrollable max-width="800px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            {{ $t('recortar_imagen') }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <clipper-fixed class="basic lg" :src="imageProfileURL" ref="clipperImageProfile" :rotate="degrees"
            :round="true" preview="preview">
          </clipper-fixed>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-col>
            <v-row xs12 class="justify-center mr-6">
              <v-slider v-model="degrees" :label="$t('grados')" step="1" max="180" min="-180"
                thumb-label="always"></v-slider>
            </v-row>
            <v-row xs12 class="justify-center">
              <v-btn color="primary" @click="getCuttingProfile()">{{ $t('recortar') }}</v-btn>
            </v-row>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <h2 class="subheading grey--text">{{ $t('contractors') }}</h2>
    <v-layout align-center justify-center fill-height>
      <v-dialog v-model="dialog" persistent scrollable max-width="600px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark v-on="on" @click="update = false,
            cleanFields()">
            + {{ $t('add_contractor') }}
          </v-btn>
        </template>
        <v-form @submit.prevent="update
          ? updatecontractor(id_update)
          : createcontractor()">
          <v-card class="elevation-5">
            <v-toolbar dark color="primary">
              <v-toolbar-title>
                {{ $t('contractors') }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn class="align-self-end" color="red" icon @click="clear(), dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-autocomplete class="mt-3 mb-3 ml-3 mr-3" v-model="idHousecontractor" prepend-icon="mdi-home-city"
                    name="idHousecontractor" :item-text="example" item-value="id" :label="$t('casas')"
                    :placeholder="$t('search_by_house_number')" :filter="customFilterHouse" :items="houses"
                    no-data-text="Ningún Resultado" :error-messages="errores.idHouse" clearable outlined
                    autocomplete="off">
                    <template v-slot:item="data">
                      <strong>{{ data.item.street === null ? 'n/a' : data.item.street }} {{ data.item.number === null ?
                        'n/a' : data.item.number }}</strong>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-show="getProfile.enable_biometric" v-model="payroll_number" prepend-icon="mdi-numeric"
                    name="payroll_number" :label="$t('payroll_number')" :error-messages="errores.payroll_number">
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-text-field v-model="first_name" prepend-icon="mdi-account" name="first_name" :label="$t('Nombre')"
                    :error-messages="errores.first_name">
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="last_name" prepend-icon="mdi-account-outline" name="last_name"
                    :label="$t('Apellido')" :error-messages="errores.last_name">
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-text-field v-model="email" prepend-icon="mdi-email" name="email" label="E-Mail"
                    :error-messages="errores.email">
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="telephone" prepend-icon="mdi-phone" name="telephone" :label="$t('celular')"
                    :error-messages="errores.telephone">
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-switch v-model="is_active" :label="is_active ? $t('Activo') : $t('Inactivo')" color="success" inset
                    prepend-icon="mdi-account-check" :error-messages="errores.is_active"></v-switch>
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                  <div class="splash-info">
                    <v-label>
                      {{ $t('foto_ine') }}<br>[{{ $t('frente') }}]
                    </v-label>
                    <br>
                    <v-img class="pt-3 pb-3" :src="resultFrontURL" v-if="resultFrontURL" width="auto"
                      height="180"></v-img>
                    <br>
                    <v-alert v-if="errores.idFront" type="error" outlined transition="scale-transition">
                      {{ errores.idFront }}
                    </v-alert>
                    <br>
                    <v-btn color="primary">
                      <clipper-upload @input="dialog = false, dialogImageFront = true, degrees = 0, ratio = '1'"
                        accept="image/*" v-model="imageFrontURL">
                        {{ update === true ? $t('update_image') : $t('subir_imagen') }}
                      </clipper-upload>
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                  <div class="splash-info">
                    <v-label>
                      {{ $t('foto_ine') }}<br>[{{ $t('reverso') }}]
                    </v-label>
                    <br>
                    <v-img class="pt-3 pb-3" :src="resultBackURL" v-if="resultBackURL" width="auto"
                      height="180"></v-img>
                    <br>
                    <v-alert v-if="errores.idBack" type="error" outlined transition="scale-transition">
                      {{ errores.idBack }}
                    </v-alert>
                    <br>
                    <v-btn color="primary">
                      <clipper-upload @input="dialog = false, dialogImageBack = true, degrees = 0, ratio = '1'"
                        accept="image/*" v-model="imageBackURL">
                        {{ update === true ? $t('update_image') : $t('subir_imagen') }}
                      </clipper-upload>
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                  <div class="splash-info">
                    <v-label>
                      {{ $t('foto_perfil') }}
                    </v-label>
                    <br>
                    <div class="wrapper">
                      <img :src="resultProfileURL" v-if="resultProfileURL">
                    </div>
                    <br>
                    <v-alert v-if="errores.avatar" type="error" outlined transition="scale-transition">
                      {{ errores.avatar }}
                    </v-alert>
                    <br>
                    <v-btn color="primary">
                      <clipper-upload @input="dialog = false, dialogImageProfile = true, degrees = 0, ratio = '1'"
                        accept="image/*" v-model="imageProfileURL">
                        {{ update === true ? $t('update_image') : $t('subir_imagen') }}
                      </clipper-upload>
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-label>{{ $t('access_days') }}</v-label>
                  <v-container fluid>
                    <v-layout row>
                      <v-checkbox color="primary" v-model="Monday" :label="$t('Lunes')" hide-details></v-checkbox>
                      <v-checkbox color="primary" v-model="Tuesday" :label="$t('Martes')" hide-details></v-checkbox>
                      <v-checkbox color="primary" v-model="Wednesday" :label="$t('Miercoles')"
                        hide-details></v-checkbox>
                    </v-layout>
                    <v-layout row>
                      <v-checkbox color="primary" v-model="Thursday" :label="$t('Jueves')" hide-details></v-checkbox>
                      <v-checkbox color="primary" v-model="Friday" :label="$t('Viernes')" hide-details></v-checkbox>
                      <v-checkbox color="primary" v-model="Saturday" :label="$t('Sabado')" hide-details></v-checkbox>
                    </v-layout>
                    <v-layout row>
                      <v-checkbox color="primary" v-model="Sunday" :label="$t('Domingo')" hide-details></v-checkbox>
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-container fluid>
                    <v-layout row wrap>
                      <v-flex sm6>
                        <v-menu v-model="menuCalendar" :close-on-content-click="false" transition="scale-transition"
                          offset-y max-width="290px" min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="computedDateFormatted" :label="$t('fecha_inicial')" hint="DD/MM/YYYY"
                              persistent-hint prepend-icon="mdi-calendar" :error-messages="errores.dateInv" readonly
                              v-on="on"></v-text-field>
                          </template>
                          <v-date-picker v-model="date" no-title :min="getCurrentDate()" :locale="$t('region')"
                            @input="menuCalendar = false"></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex sm6>
                        <v-menu v-model="menuCalendarExpiration" :close-on-content-click="false"
                          transition="scale-transition" offset-y max-width="290px" min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="computedDateExpirationFormatted" :label="$t('fecha_expiracion')"
                              hint="DD/MM/YYYY" persistent-hint prepend-icon="mdi-calendar"
                              :error-messages="errores.expiration" readonly v-on="on"></v-text-field>
                          </template>
                          <v-date-picker v-model="dateExpiration" no-title :min="getCurrentDate()"
                            :locale="$t('region')" @input="menuCalendarExpiration = false"></v-date-picker>
                        </v-menu>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12 sm6>
                        <v-menu ref="menuCheckInTime" v-model="menuCheckInTime" :close-on-content-click="false"
                          :nudge-right="40" :return-value.sync="checkInTime" transition="scale-transition" offset-y
                          max-width="290px" min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="checkInTime" :label="$t('check_in_time')" prepend-icon="mdi-clock"
                              :error-messages="errores.check_in_time" readonly v-on="on"></v-text-field>
                          </template>
                          <v-time-picker v-if="menuCheckInTime" v-model="checkInTime" scrollable format="24hr"
                            @click:minute="$refs.menuCheckInTime.save(checkInTime)"></v-time-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-menu ref="menuCheckOutTime" v-model="menuCheckOutTime" :close-on-content-click="false"
                          :nudge-right="40" :return-value.sync="checkOutTime" transition="scale-transition" offset-y
                          max-width="290px" min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="checkOutTime" :label="$t('check_out_time')" prepend-icon="mdi-clock"
                              :error-messages="errores.check_out_time" readonly v-on="on"></v-text-field>
                          </template>
                          <v-time-picker v-if="menuCheckOutTime" v-model="checkOutTime" scrollable format="24hr"
                            @click:minute="$refs.menuCheckOutTime.save(checkOutTime)"></v-time-picker>
                        </v-menu>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-layout>
              <v-alert :value=alerta type="warning" outlined transition="scale-transition">
                Fallo con el Servidor
              </v-alert>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click="clear(),
                dialog = false">{{ $t('cerrar') }}
              </v-btn>
              <v-spacer />
              <v-btn v-if="update" :loading="loading" color="primary" type="submit">{{ $t('modificar') }}
              </v-btn>
              <v-btn v-else :loading="loading" color="primary" type="submit">{{ $t('agregar') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-layout>
    <v-layout class="my-4" align-center justify-center fill-height>
      <v-flex>
        <v-card class="elevation-5">
          <v-toolbar dark color="primary">
            <v-toolbar-title>
              {{ $t('contractors') }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-layout row wrap class="my-4" align-center justify-center fill-height>
              <v-flex xs8>
                <v-card-title class="justify-center">
                  <v-text-field outlined clearable v-model="search" append-icon="mdi-magnify" :label="$t('Buscar')"
                    :placeholder="$t('Buscar')"></v-text-field>
                </v-card-title>
              </v-flex>
              <v-flex xs4>
                <v-card-title class="justify-center">
                  <v-autocomplete v-model="idHouse" prepend-icon="mdi-home-city" name="idHouse" :item-text="example"
                    item-value="id" :label="$t('casas')" :placeholder="$t('search_by_house_number')"
                    :filter="customFilterHouse" :items="houses" no-data-text="Ningún Resultado" clearable outlined
                    autocomplete="off">
                    <template v-slot:item="data">
                      <strong>{{ data.item.street === null ? 'n/a' : data.item.street }} {{ data.item.number === null ?
                        'n/a' : data.item.number }}</strong>
                    </template>
                  </v-autocomplete>
                </v-card-title>
              </v-flex>
              <v-flex xs12>
                <v-btn v-show="selected.length > 0" color="green" block :loading="loadingSendPrint" @click="sendPrint">
                  {{ $t('display_info_print') }} ({{ selected.length }})
                </v-btn>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs12>
                <v-data-table v-model="selected"
                  show-select item-key="id"
                  :headers="headers2"
                  :loading="loadingcontractors"
                  :items="contractors" :search="search" :footer-props="{
                    itemsPerPageOptions: [
                      { text: '12', value: 12 },
                      { text: '24', value: 24 },
                      { text: '48', value: 48 },
                      { text: this.$t('todos'), value: -1 }
                    ],
                    itemsPerPageText: $t('filas_por_pagina')
                  }" :no-data-text="$t('no_records_yet')" class="elevation-1">
                  <template v-slot:items="props">
                    <td>{{ props.item.id }}</td>
                    <td>{{ props.item.id_usuario.first_name }}</td>
                    <td>{{ props.item.id_usuario.last_name }}</td>
                  </template>

                  <!-- Slot para el badge de is_active -->
                  <template v-slot:item.is_active="{ item }">
                    <v-chip small :color="item.is_active ? 'green' : 'red'" text-color="white">
                      {{ item.is_active ? $t('Activo') : $t('Inactivo ') }}
                    </v-chip>
                  </template>

                  <template v-slot:item.telephone="{ item }">
                    <td>{{ (item.telephone === '' || item.telephone === null) ? 'n/a' : item.telephone }}</td>
                  </template>

                  <template v-slot:item.email="{ item }">
                    <td>{{ (item.email === '' || item.email === null) ? 'n/a' : item.email }}</td>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" medium color="gray" class="mr-2"
                          @click="fillFields(item), update = true, dialog = true, id_update = item.id">
                          mdi-account-edit
                        </v-icon>
                      </template>
                      <span>{{ $t('show_details') }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" medium color="gray" class="mr-2"
                          @click="sendInfoDialog = true, idcontractorSendInfo = item.id">
                          mdi-send
                        </v-icon>
                      </template>
                      <span>{{ $t('send_details') }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" medium color="red" class="mr-2"
                          @click="deleteDialog = true, idcontractorDelete = item.id">
                          mdi-delete
                        </v-icon>
                      </template>
                      <span>{{ $t('delete') }}</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:no-results>
                    <v-alert type="warning">
                      {{ $t('ningun_resultado_1') }} "{{ search }}" {{ $t('ningun_resultado_2') }}
                    </v-alert>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
/* eslint-disable space-before-function-paren */

import axios from 'axios'
import store from '@/store'
import VuejsClipper from 'vuejs-clipper'
import { mapState, mapGetters } from 'vuex'
import Vue from 'vue'

Vue.use(VuejsClipper, {
  components: {
    clipperBasic: 'clipper-basic',
    clipperFixed: 'clipper-fixed',
    clipperUpload: 'clipper-upload'
  }
})

// Constantes
const API_BASE_URL = 'https://residencial-services.intrare.app'
const IMAGE_QUALITY = 0.2
const WEEKDAYS = {
  Monday: '0',
  Tuesday: '1',
  Wednesday: '2',
  Thursday: '3',
  Friday: '4',
  Saturday: '5',
  Sunday: '6'
}

export default {
  name: 'ContractorsAdmin',

  data: () => ({
    // UI States
    show: false,
    alerta: false,
    dialog: false,
    dialogQR: false,
    dialogImageProfile: false,
    dialogImageFront: false,
    dialogImageBack: false,
    dialogGuest: false,
    deleteDialog: false,
    dialogAtLeastOneDay: false,
    sendInfoDialog: false,
    idcontractorSendInfo: 0,
    // Loading States
    loading: false,
    loadingcontractors: false,
    loadingSendPrint: false,
    loadingSendInfo: false,
    // Data
    contractors: [],
    houses: [],
    selected: [],
    errores: [],

    // Form Fields
    update: false,
    id_update: 0,
    first_name: '',
    last_name: '',
    email: '',
    telephone: '',
    is_active: false,
    payroll_number: '',
    idHousecontractor: null,
    checkInTime: '',
    checkOutTime: '',
    date: '',
    dateExpiration: '',

    // Auxiliary Fields (for update comparison)
    first_name_aux: '',
    last_name_aux: '',
    idHousecontractor_aux: null,
    checkInTime_aux: '',
    checkOutTime_aux: '',
    email_aux: '',
    telephone_aux: '',
    is_active_aux: false,
    date_aux: '',
    dateExpiration_aux: '',
    days_aux: '',

    // Weekdays
    Monday: false,
    Tuesday: false,
    Wednesday: false,
    Thursday: false,
    Friday: false,
    Saturday: false,
    Sunday: false,

    // Images
    imageProfileURL: '',
    resultProfileURL: '',
    resultAuxProfileURL: '',
    imageFrontURL: '',
    resultFrontURL: '',
    resultAuxFrontURL: '',
    imageBackURL: '',
    resultBackURL: '',
    resultAuxBackURL: '',

    // Table
    headers: [],
    headers2: [],
    search: '',
    idHouse: null,

    // Others
    bandGuest: false,
    degrees: 0,
    ratio: '1',
    idcontractorDelete: 0,
    menuCalendar: false,
    menuCalendarExpiration: false,
    menuCheckInTime: '',
    menuCheckOutTime: ''
  }),
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date)
    },

    computedDateExpirationFormatted() {
      return this.formatDate(this.dateExpiration)
    },

    selectedWeekdays() {
      return Object.entries(WEEKDAYS)
        .filter(([day]) => this[day])
        .map(([, value]) => value)
        .join('')
    },

    hasSelectedDays() {
      return Object.keys(WEEKDAYS).some(day => this[day])
    },

    ...mapState(['language']),
    ...mapGetters(['getProfile'])
  },

  created() {
    this.initializeComponent()
  },

  beforeUpdate() {
    this.updateHeaders()
  },

  methods: {
    // ============ Initialization ============
    async initializeComponent() {
      await Promise.all([
        this.getHouses(),
        this.getcontractors()
      ])
    },

    updateHeaders() {
      const commonHeaders = [
        {
          text: this.$t('acciones'),
          align: 'center',
          value: 'action',
          sortable: false
        },
        {
          text: this.$t('Activo'),
          align: 'left',
          sortable: false,
          value: 'is_active'
        },
        {
          text: this.$t('Nombre'),
          align: 'left',
          sortable: true,
          value: 'first_name'
        },
        {
          text: this.$t('Apellido'),
          align: 'left',
          sortable: true,
          value: 'last_name'
        },
        {
          text: 'E-Mail',
          align: 'left',
          sortable: true,
          value: 'email'
        },
        {
          text: this.$t('celular'),
          align: 'left',
          sortable: true,
          value: 'telephone'
        },
        {
          text: this.$t('direccion'),
          align: 'left',
          sortable: true,
          value: 'address'
        },
        {
          text: 'ID',
          align: 'center',
          sortable: false,
          value: 'idHouse',
          filter: this.idHouseFilter
        }
      ]

      this.headers = [
        commonHeaders[0],
        {
          text: this.$t('payroll_number'),
          align: 'left',
          sortable: true,
          value: 'payroll_number'
        },
        ...commonHeaders.slice(1)
      ]

      this.headers2 = [...commonHeaders]
    },

    // ============ API Calls ============
    async getHouses() {
      try {
        const response = await this.apiCall('get', '/house/')
        this.houses = response.data
      } catch (error) {
        console.error('Error fetching houses:', error)
      }
    },

    async getcontractors() {
      this.loadingcontractors = true
      try {
        const response = await this.apiCall('get', '/contractor_admin/')
        this.contractors = response.data
      } catch (error) {
        console.error('Error fetching contractors:', error)
      } finally {
        this.loadingcontractors = false
      }
    },

    async getAdminBase64contractors(records) {
      this.loadingSendPrint = true
      try {
        const response = await this.apiCall('post', '/contractor_admin/base64/list', records)
        this.contractorsAdminBase64 = response.data
        localStorage.setItem('listPrint', JSON.stringify(this.contractorsAdminBase64))
        window.open('/print', 'Print')
      } catch (error) {
        console.error('Error fetching base64:', error)
      } finally {
        this.loadingSendPrint = false
      }
    },

    async createcontractor() {
      if (!this.hasSelectedDays) {
        this.dialogAtLeastOneDay = true
        return
      }

      this.errores = []
      this.loading = true

      try {
        const formData = this.buildFormData()
        await this.apiCall('post', '/contractor_admin_post/', formData)

        await this.getcontractors()
        this.showSuccessMessage(this.$t('msg_contractor_added'))
        this.closeDialog()
      } catch (error) {
        this.handleError(error)
      } finally {
        this.loading = false
      }
    },

    async updatecontractor(id) {
      if (!this.hasSelectedDays) {
        this.dialogAtLeastOneDay = true
        return
      }

      this.errores = []
      this.loading = true

      try {
        const formData = this.buildFormDataForUpdate()
        await this.apiCall('patch', `/contractor_admin_post/${id}/`, formData)

        await this.getcontractors()
        this.showSuccessMessage(this.$t('msg_contractor_update'))
        this.closeDialog()
      } catch (error) {
        this.handleError(error)
      } finally {
        this.loading = false
      }
    },

    async sendContractorInfo() {
      this.loadingSendInfo = true
      try {
        await this.apiCall('post', `/contractor_admin_post/${this.idcontractorSendInfo}/send_info/`)
        this.showSuccessMessage(this.$t('msg_contractor_send_info'))
        this.sendInfoDialog = false
        setTimeout(this.clear, 3000)
      } catch (error) {
        this.handleError(error)
      } finally {
        this.loadingSendInfo = false
      }
    },

    async deletecontractor() {
      try {
        await this.apiCall('delete', `/contractor_admin_post/${this.idcontractorDelete}/`)

        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('msg_contractor_deleted'))

        await this.getcontractors()
        this.deleteDialog = false
        setTimeout(this.clear, 3000)
      } catch (error) {
        this.handleError(error)
      }
    },

    // ============ Helper Methods ============
    apiCall(method, endpoint, data = null) {
      const config = {
        method,
        url: `${API_BASE_URL}${endpoint}`,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': `Token ${store.getters.getToken}`
        }
      }

      if (data) {
        config.data = data
      }

      return axios(config)
    },

    buildFormData() {
      const formData = new FormData()

      formData.set('first_name', this.first_name)
      formData.set('last_name', this.last_name)
      formData.set('payroll_number', this.payroll_number)
      formData.set('check_in_time', this.checkInTime)
      formData.set('check_out_time', this.checkOutTime)
      formData.set('initial_date', this.date)
      formData.set('final_date', this.dateExpiration)
      formData.set('diary', this.selectedWeekdays)
      formData.set('idHouse', this.idHousecontractor)
      formData.set('email', this.email)
      formData.set('telephone', this.telephone)
      formData.set('is_active', this.is_active)

      this.appendImages(formData, {
        avatar: this.resultProfileURL,
        idFront: this.resultFrontURL,
        idBack: this.resultBackURL
      })

      return formData
    },

    buildFormDataForUpdate() {
      const formData = new FormData()
      const weekdays = this.selectedWeekdays

      // Only append changed fields
      if (this.idHousecontractor !== this.idHousecontractor_aux) {
        formData.set('idHouse', this.idHousecontractor)
      }
      if (this.first_name !== this.first_name_aux) {
        formData.set('first_name', this.first_name)
      }
      if (this.last_name !== this.last_name_aux) {
        formData.set('last_name', this.last_name)
      }
      if (this.days_aux !== weekdays) {
        formData.set('diary', weekdays)
      }
      if (this.date_aux !== this.date) {
        formData.set('initial_date', this.date)
      }
      if (this.dateExpiration_aux !== this.dateExpiration) {
        formData.set('final_date', this.dateExpiration)
      }
      if (this.checkInTime_aux !== this.checkInTime) {
        formData.set('check_in_time', this.checkInTime)
      }
      if (this.checkOutTime_aux !== this.checkOutTime) {
        formData.set('check_out_time', this.checkOutTime)
      }
      if (this.email !== this.email_aux) {
        formData.set('email', this.email)
      }
      if (this.telephone !== this.telephone_aux) {
        formData.set('telephone', this.telephone)
      }

      formData.set('is_active', this.is_active)

      formData.set('payroll_number', this.payroll_number)

      // Handle image updates
      if (this.resultProfileURL !== this.resultAuxProfileURL) {
        const file = this.createImageFile(this.resultProfileURL, 'avatar')
        if (file) formData.append('avatar', file)
      }
      if (this.resultFrontURL !== this.resultAuxFrontURL) {
        const file = this.createImageFile(this.resultFrontURL, 'ine_front')
        if (file) formData.append('idFront', file)
      }
      if (this.resultBackURL !== this.resultAuxBackURL) {
        const file = this.createImageFile(this.resultBackURL, 'ine_back')
        if (file) formData.append('idBack', file)
      }

      return formData
    },

    appendImages(formData, images) {
      Object.entries(images).forEach(([key, dataUrl]) => {
        const prefix = key === 'avatar' ? 'avatar' : key === 'idFront' ? 'ine_front' : 'ine_back'
        const file = this.createImageFile(dataUrl, prefix)
        formData.append(key, file)
      })
    },

    createImageFile(dataUrl, prefix) {
      if (!dataUrl || dataUrl.length <= 6) return null
      const filename = `${prefix}_${this.$uuid.v4()}.jpeg`
      return this.dataURLtoFile(dataUrl, filename)
    },

    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      const n = bstr.length
      const u8arr = new Uint8Array(n)

      for (let i = 0; i < n; i++) {
        u8arr[i] = bstr.charCodeAt(i)
      }

      return new File([u8arr], filename, { type: mime })
    },

    // ============ UI Methods ============
    fillFields(item) {
      this.idHousecontractor = item.idHouse
      this.idHousecontractor_aux = item.idHouse
      this.first_name = item.first_name
      this.first_name_aux = item.first_name
      this.last_name = item.last_name
      this.last_name_aux = item.last_name
      this.payroll_number = item.payroll_number || ''
      this.email = item.email || ''
      this.email_aux = item.email || ''
      this.telephone = item.telephone || ''
      this.telephone_aux = item.telephone || ''
      this.is_active = item.is_active || false

      this.fillDays(item.diary)
      this.days_aux = item.diary

      this.checkInTime = item.check_in_time
      this.checkInTime_aux = item.check_in_time
      this.checkOutTime = item.check_out_time
      this.checkOutTime_aux = item.check_out_time

      this.date = item.initial_date
      this.date_aux = item.initial_date
      this.dateExpiration = item.final_date
      this.dateExpiration_aux = item.final_date

      this.resultProfileURL = item.avatar
      this.resultAuxProfileURL = item.avatar
      this.resultFrontURL = item.idFront
      this.resultAuxFrontURL = item.idFront
      this.resultBackURL = item.idBack
      this.resultAuxBackURL = item.idBack
    },

    fillDays(days) {
      Object.keys(WEEKDAYS).forEach(day => {
        this[day] = days.includes(WEEKDAYS[day])
      })
    },

    cleanFields() {
      this.idHousecontractor = null
      this.idHousecontractor_aux = null
      this.timeNow()

      const today = new Date().toISOString().substr(0, 10)
      this.date = today
      this.dateExpiration = today

      this.first_name = ''
      this.first_name_aux = ''
      this.last_name = ''
      this.last_name_aux = ''
      this.payroll_number = ''
      this.email = ''
      this.telephone = ''
      this.is_active = false

      Object.keys(WEEKDAYS).forEach(day => {
        this[day] = false
      })

      this.resultProfileURL = ''
      this.resultFrontURL = ''
      this.resultBackURL = ''
    },

    closeDialog() {
      this.dialog = false
      setTimeout(this.clear, 3000)
    },

    clear() {
      this.alerta = false
      this.errores = []
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    },

    showSuccessMessage(message) {
      this.$store.commit('snackbar_activate_true')
      this.$store.commit('snackbar_change_message', message)
    },

    handleError(error) {
      console.error('API Error:', error)
      if (error.response.status === 400 && error.response.data) {
        this.errores = error.response.data
      }
    },

    // ============ Image Methods ============
    getCuttingProfile() {
      const canvas = this.$refs.clipperImageProfile.clip()
      this.resultProfileURL = canvas.toDataURL('image/jpeg', IMAGE_QUALITY)
      this.dialogImageProfile = false

      if (this.bandGuest) {
        this.dialogGuest = true
      } else {
        this.dialog = true
      }
    },

    getCuttingFront() {
      const canvas = this.$refs.clipperImageFront.clip()
      this.resultFrontURL = canvas.toDataURL('image/jpeg', IMAGE_QUALITY)
      this.dialogImageFront = false
      this.dialog = true
    },

    getCuttingBack() {
      const canvas = this.$refs.clipperImageBack.clip()
      this.resultBackURL = canvas.toDataURL('image/jpeg', IMAGE_QUALITY)
      this.dialogImageBack = false
      this.dialog = true
    },

    // ============ Filters ============
    idHouseFilter(value) {
      if (!this.idHouse) return true
      return value.toLowerCase().includes(this.idHouse.toLowerCase())
    },

    customFilterHouse(item, queryText) {
      const text = item.number || 'n/a'
      return text.toLowerCase().includes(queryText.toLowerCase())
    },

    customFilter(item, queryText) {
      return item.street.toLowerCase().includes(queryText.toLowerCase())
    },

    // ============ Utility Methods ============
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    getCurrentDate() {
      return new Date().toISOString().split('T')[0]
    },

    timeNow() {
      const d = new Date()
      const h = String(d.getHours()).padStart(2, '0')
      const m = String(d.getMinutes()).padStart(2, '0')
      this.checkInTime = `${h}:${m}`
      this.checkOutTime = `${h}:${m}`
    },

    example: item => {
      const street = item.street || 'n/a'
      const number = item.number || 'n/a'
      return `${street} ${number}`
    },

    async sendPrint() {
      const records = this.selected.map(item => item.id)
      await this.getAdminBase64contractors(records)
    }
  }
}
</script>
